// libs
import { connect } from 'react-redux';

// component
import API from './API';

// actions
import {
  addProductsToWishlistProducts,
  addProductToWishlist,
  fetchProductData,
  resetWishlistTotalCountProductsAndPages,
  updateProductSKUFromWishlistStore,
} from 'shared/store/wishlist/actions';
import { removeFromWishlist } from 'shared/store/wishlist/services';

// selectors
import { getPagesFetched, getTotalCount } from 'shared/store/wishlist/selectors';
import {
  getCartNudgeCount,
  getCustomerFirstName,
  isLoggedIn,
  isUserFetching,
} from 'shared/store/app/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';
import { setCartNudge } from 'store/app/actions';

const mapStateToProps = (state: any) => ({
  pages: getPagesFetched(state),
  isUserLoggedIn: isLoggedIn(state),
  isUserFetching: isUserFetching(state),
  totalProducts: getTotalCount(state),
  firstName: getCustomerFirstName(state),
  wishlistConfig: getRemoteConfig(state, 'wishlist'),
  cartNudgeCount: getCartNudgeCount(state),
});
const mapDispatchToProps = {
  addProductsToWishlistStore: addProductsToWishlistProducts,
  addSingleProductToWishlistStore: addProductToWishlist,
  resetWishlistTotalCountProductsAndPages,
  fetchProductData,
  updateProductSKUFromWishlistStore,
  removeFromWishlist,
  setCartNudge: setCartNudge,
};

export default connect(mapStateToProps, mapDispatchToProps)(API);
